const APPLE_PAY_EU_COUNTRIES = new Set([
    'FR',
    'AT',
    'BE',
    'HR',
    'CY',
    'CZ',
    'EE',
    'FI',
    'DE',
    'GR',
    'IE',
    'IT',
    'LT',
    'LU',
    'MT',
    'NL',
    'PL',
    'PT',
    'RO',
    'SK',
    'SI',
    'ES',
    'SE',
    'DK'
])

const APPLE_PAY_EU_SITES = new Set(['VBQ-EU', 'VBQ-OUTLET-EU'])
const APPLE_PAY_US_SITES = new Set(['VBQ-US', 'VBQ-OUTLET-US'])

export const isApplePayCountryEligible = (siteId, countryCode) => {
    if (APPLE_PAY_EU_SITES.has(siteId)) {
        return APPLE_PAY_EU_COUNTRIES.has(countryCode)
    }

    return APPLE_PAY_US_SITES.has(siteId) && countryCode === 'US'
}
